<template>
  <div id="roll-call" v-if="show">
        <!-- 抢答准备 -->
        <div class="interact-tea-ans-content interact-tea-bg" :class="{'interact-active':answer_status}"  v-if="ready_status">
            <div class="random-smoke" v-if="radom_call_show" @click="random_answer">随机点名</div>
            <div class="interact-close" @click="close"></div>
            <div class="ready">
                <div class="interact-time">
                <!-- {{time}} -->
                <span>{{time[0]}}</span>
                <span>{{time[1]}}</span>
                <span class="colon">{{time[2]}}</span>
                <span>{{time[3]}}</span>
                <span>{{time[4]}}</span>
                <span class="colon">{{time[5]}}</span>
                <span>{{time[6]}}</span>
                <span>{{time[7]}}</span>
                </div>
                <div class="interact-answer-btn" @click="start"></div>
            </div>
        </div>
        <!-- 抢答结果 1人 -->
        <div class="interact-tea-ans-content interact-tea-result-one-bg" v-if="result_status">
            <div class="random-smoke" v-if="radom_call_show" @click="random_answer">随机点名</div>
            <div class="interact-close" @click="close"></div>
            <div class="result">
                <div class="interact-result-title">抢答成功的同学是</div>
                <div class="interact-result">
                    <div class="result-no1">{{result_name1}}</div>
                </div>
                <div class="next-interact" @click="next">下一轮抢答</div>
            </div>
        </div>
        <!-- 抢答结果 2-3人 -->
        <div class="interact-tea-ans-content interact-tea-result-bg" v-if="result_three_status">
            <div class="random-smoke" v-if="radom_call_show" @click="random_answer">随机点名</div>
            <div class="interact-close" @click="close"></div>
            <div class="result">
                <div class="interact-result-title">抢答成功的同学是</div>
                <div class="interact-result">
                    <div class="result-no3">{{result_name3}}</div>
                    <div class="result-no2">{{result_name2}}</div>
                    <div class="result-no1">{{result_name1}}</div>
                </div>
                <div class="next-interact" @click="next">下一轮抢答</div>
            </div>
        </div>
        <!-- 随机点名 -->
         <div class="interact-tea-ans-content interact-tea-result-one-bg" v-if="random_result_status">
            <div class="random-smoke" v-if="radom_call_show" @click="random_answer">继续点名</div>
            <div class="interact-close" @click="close"></div>
            <div class="result">
                <div class="interact-result-title"></div>
                <div class="interact-result">
                    <div class="result-no1">{{result_name1}}</div>
                </div>
                <div class="next-interact" @click="next">使用抢答</div>
            </div>
        </div>
        <!-- 学生端 准备页面 -->
        <div class="interact-tea-ans-content" v-if="student_answer_ready">
            <div class="interact-stu-ready"></div>
        </div>
        <!-- 学生端抢答页面 -->
        <div class="interact-tea-ans-content" v-if="student_answer_responder">
            <div class="interact-stu-answer">
                <div class="interact-stu-answer-btn" @click="studentAnswer"></div>
            </div>
        </div>
        <!-- 学生端抢答成功页面 -->
        <div class="interact-tea-ans-content" v-if="student_answer_success">
            <div class="interact-stu-answer-success">
                <p>抢答成功</p>
                <p>请准备回答问题</p>
            </div>
        </div>
        <!-- 学生端抢答失败页面 -->
        <div class="interact-tea-ans-content" v-if="student_answer_fail">
            <div class="interact-stu-answer-fail">
                <p>抢答机会已被 <b>{{student_name_success}}</b> 同学获得把握好下次机会喔~~~</p>
            </div>
        </div>
        <!-- 学生被抽点到页面 -->
        <div class="interact-tea-ans-content random-sucess" v-if="student_random_success">
            <div class="interact-stu-answer-success">
                <p>已被点名</p>
                <p>请准备回答问题</p>
            </div>
        </div>
        <!-- 学生未被抽点到页面 -->
        <div class="interact-tea-ans-content random-fail" v-if="student_random_fail">
            <div class="interact-stu-answer-fail student-fail">
                <p>
                    <b>{{student_name_success}}</b> 同学已被老师随机抽中点名，不要灰心哦！
                </p>
            </div>
        </div>
  </div>
</template>

<script>
export default {
  name: "roll-call",
  data() {
    return {
      //是否显示抢答
      show:false,
      //老师端计时器
      timer:null,
      //老师端计时器时间
      time:'00:00:00',
      //老师端抢答开始
      answer_status:false,
      //老师端抢答准备
      ready_status:false,
      //老师端抢答结果（一人）
      result_status:false,
      //老师端抢答结果（三人）
      result_three_status:false,
      //老师端随机点名结果
      random_result_status:false,
      //学生端抢答准备
      student_answer_ready:false,
      //学生端抢答
      student_answer_responder:false,
      //学生端抢答成功
      student_answer_success:false,
      //学生端抢答失败
      student_answer_fail:false,
      //随机点名成功
      student_random_success:false,
      //随机点名失败
      student_random_fail:false,
      //抢答成功第1个学生
      result_name1:'',
      //抢答成功第2个学生
      result_name2:'',
      //抢答成功第3个学生
      result_name3:'',
      //随机点名选中学生
      student_name_success:'',
      //更新组件
      key:0,
      start_time:0,
      //开始时间状态
      start_status: false,
      //随机点名状态
      radom_call_show: false,
        is_random_call:false,
    };
  },
  computed: {
    answersen() {
        return this.$store.state.interaction.answer_Receive
    }
  },
  watch: {
      answersen(val){
          console.log(val);
          this.show = false;
          this.answer_status = false;
          this.ready_status = false;
          this.result_status = false;
          this.result_three_status = false;
          this.random_result_status = false;
          this.student_answer_ready = false;
          this.student_answer_responder = false;
          this.student_answer_success = false;
          this.student_answer_fail = false;
          this.student_random_success = false;
          this.student_random_fail = false;
          if(val.event_name != "event_answer_start") {
              this.start_status = false;
              clearInterval(this.timer);
          }
          this.result_name1 = '';
          this.result_name2 = '';
          this.result_name3 = '';
          this.student_name_success = '';
          if(this.key > 10){
              this.key = 0;
          }
          this.publicRec(val);
      }
  },
  methods: {
    //公共接受事件
    publicRec(parseData){
        const type = parseData.event_name;
        if(this.$cookies.get("user_type") == this.identity.teacher){
            if(this.$cookies.get("user_id") != parseData.data.teacher_id){
                return;
            }
            this.$cookies.set("event_id",parseData.data.event_id);
            this.radom_call_show = parseData.data.radom_call_show;
            switch(type){
                case 'event_answer_ready':
                        this.time = '00:00:00';
                        this.show = true;
                        this.ready_status = true;
                    break;
                case 'event_answer_start':
                        this.answer_status = true;
                        this.show = true;
                        this.ready_status = true;
                        //let start_time = parseData.data.start_time ? parseData.data.start_time : new Date().getTime();
                        if(!this.start_status){
                            this.start_time = new Date().getTime();
                            this.timer = setInterval(function(){
                                this.time = this.formateAnswerTime(this.start_time);
                            }.bind(this),30)
                        }
                        this.start_status = true;
                    break;
                case 'event_answer_system_stop':
                        console.log("不做处理");
                    break;
                case 'event_answer_result':
                        const data = parseData.data.answer_pool;
                        this.show = true;
                        this.ready_status = true;
                        this.result_status = true;
                        this.result_name1 = data[0].student_name;
                        if( data.length>1){
                            this.result_name2 = data[1] ? data[1].student_name : "";
                            this.result_name3 = data[2] ? data[2].student_name : "";
                            this.result_three_status = true;
                        }else{
                            this.result_status = true;
                        }
                    break;
                case 'event_random_answer_result':
                    if(this.is_random_call && (parseData.data.answer_pool&& parseData.data.answer_pool.length==0)){//若是随机点名 结果为空代表班级人数为空
                        this.show = true;
                        this.ready_status = true;
                        this.random_result_status = false;
                        return;
                    }
                    const random_data = parseData.data.answer_pool;
                    this.show = true;
                    this.random_result_status = true;
                    this.result_name1 = random_data[0].student_name;
                    console.log("我是老师随机点名处理结果");
                    break;
                default:
                console.log("无该类型")
            }
        }
        if(this.$cookies.get("user_type") == this.identity.student){
            this.$cookies.set("event_id",parseData.data.event_id);
            switch(type){
                case 'event_answer_ready':
                        this.show = true;
                        this.student_answer_ready = true;
                        console.log(parseData);
                    break;
                case 'event_answer_start':
                        this.show = true;
                        this.student_answer_responder = true;
                    break;
                case 'event_answer_system_stop':
                        console.log("不做处理");
                    break;
                case 'event_answer_result':
                        const data = parseData.data.answer_pool;
                        this.show = true;
                        if(data[0].student_id == this.$cookies.get("user_id")){
                            this.student_answer_success  = true;
                        }else{
                            this.student_answer_fail = true;
                            this.student_name_success = data[0].student_name;
                        }
                    break;
                case 'event_random_answer_result':
                    const random_data = parseData.data.answer_pool;
                    this.show = true;
                    if(random_data[0].student_id == this.$cookies.get("user_id")){
                        this.student_random_success  = true;
                    }else{
                        this.student_random_fail = true;
                        this.student_name_success = random_data[0].student_name;
                    }
                    break;
                default:
                console.log("无该类型")
            }
        }
    },
    //开始抢答
    start(){
        if(this.answer_status){
            this.$store.commit('answersend',this.key+'&event_answer_system_stop');
        }else{
            this.$store.commit('answersend',this.key+'&event_answer_start');
        }
        this.key++;
        this.$flydata.flydataTrack(66);
    },
    //关闭抢答事件
    close(){
        this.show = false;
        this.$store.commit('answersend',this.key+'&event_answer_system_stop');
        this.key++;
    },
    //下一轮抢答
    next(){
        this.is_random_call = false;
        this.$store.commit('answersend',this.key+'&event_answer_ready');
        this.key++;
    },
    //随机点名
    random_answer(){
        this.is_random_call = true;
        this.$store.commit('answersend',this.key+'&event_random_answer');
        this.key++;
        this.$flydata.flydataTrack(67);
    },
    //学生端抢答
    studentAnswer(){
        this.$store.commit('answersend',this.key+'&event_answer_student_sent');
        this.key++;
    },
    //时间计算
    formateAnswerTime(start_time) {
        let calcMs = new Date().getTime() - start_time; //real time
        let time = calcMs;
        let ms = time;
        let m,
            s
        let result = '';
        s = Math.floor(time / 1000);
        m = Math.floor(s / 60);
        if (s >= 60) {
            s = Math.floor(s % 60);
        }
        ms = parseInt((parseInt(ms % 1000) / 1000).toFixed(2) * 100);
        if (ms >= 100) {
            ms = 0;
        }
        if (m >= 0) {
            if (m > 10) {
                result = result + m + ':'
            } else {
                result = result + '0' + m + ':'
            }
        } else {
            result = result + '00:'
        }

        if (s > 0) {
            if (s >= 10) {
                result = result + s + '.'
            } else {
                result = result + '0' + s + '.'
            }
        } else {
            result = result + '00.'
        }

        if (ms >= 10) {
            result = result + ms;
        } else {
            result = result + '0' + ms;
        }
        return result;
    }
  },
  created() {},
  components: {},
  mounted() {}
};
</script>

<style lang="scss" scoped>
  #roll-call {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 9999999;
      width: 100%;
      height:100%;
      background: rgba($color: #000000, $alpha: 0.2);

      /* 教师抢答 */

      .ready {
          width: 100%;
          height: 100%;
      }

      .interact-tea-ans-content {
          width: 360px;
          height: 400px;
          position: absolute;
          /* left: 50%; */
          left: calc(50% - 180px);
          /* top: 200px; */
          top: calc(50% - 200px);
          /* margin-left: -190px; */
          overflow: hidden;
          border-radius: 0;
          z-index: 10401;
          -moz-user-select: none;
          -webkit-user-select: none;
          user-select: none;
      }

      .interact-tea-bg {
          background:url("../../assets/images/teacher-answer-bg_new.png") no-repeat center center;
      }

      .interact-tea-ans-content .interact-close {
          position: absolute;
          right: 10px;
          top: 10px;
          width: 28px;
          height: 28px;
          background: url("../../assets/images/interact-close_new.png") no-repeat center center;
          cursor: pointer;
      }

      .interact-tea-ans-content .interact-close-white {
          // background: url("../../assets/images/interact-close_white.png") no-repeat center center;
      }

      .interact-tea-ans-content .interact-time {
          width: 58%;
          height: 54%;
          margin: 60px auto 0;
          padding-top: 27%;
          background: url("../../assets/images/interact-teacher-bg_new.png") no-repeat center bottom;
          background-size: 100% auto;
          font-size: 36px;
          color: #AD4444;
          text-align: center;
      }

      .interact-time span {
        width: 24px;
        display: inline-block;
        margin-right: -3px;
      }

       .interact-time .colon {
        width: 16px;
        vertical-align: top;
        line-height: 42px;
      }

      .interact-tea-ans-content.interact-active .interact-time {
          /* background: url("../../assets/images/interact-teacher-bg1_new.png") no-repeat center bottom; */
          background-size: 100% auto;
      }

      .interact-tea-ans-content .interact-answer-btn {
          width: calc(100% - 60px);
          height: 20%;
          margin: 30px auto 0;
          background: url("../../assets/images/interact-teacher-btn_new.png") no-repeat center center;
          background-size: 100% auto;
          cursor: pointer;
      }

      .interact-tea-ans-content.interact-active .interact-answer-btn {
          background: url("../../assets/images/interact-teacher-stop-btn_new.png") no-repeat center center;
          background-size: 100% auto;
      }

      /* 抢答结果 */

      .interact-tea-result-bg {
          background: url('../../assets/images/interact-resukt_new.png') no-repeat center center;
          background-size: 100% auto;
      }

      .interact-tea-result-one-bg {
          background: url('../../assets/images/interact-resukt_one_new.png') no-repeat center center;
          background-size: 100% auto;
      }

      .interact-tea-result-two-bg {
          background: url('../../assets/images/interact-resukt_two_new.png') no-repeat center center;
          background-size: 100% auto;
      }

      .interact-result-title {
          min-height: 0.32rem;
          margin: 63px auto 18px;
          font-size: 24px;
          text-align: center;
          color: #666666;
      }

      .interact-result {
          position: relative;
          width: 100%;
          height: 300px;
      }

      .interact-result div {
          position: absolute;
          width: 100%;
          color: #999999;
      }

      .interact-result .result-no1 {
          top: 0;
          font-size: 42px;
          color: #EC7C4E;
          font-weight: bold;
          text-align: center;
      }

      .interact-result .result-no2 {
          left: 4%;
          top: 68px;
          width: 40%;
          height: 50%;
          text-align: center;
      }

      .interact-result .result-no3 {
          right: 4%;
          top: 84px;
          width: 40%;
          height: 50%;
          text-align: center;
      }

      .interact-tea-ans-content .next-interact {
          position: absolute;
          width: 100%;
          left: 0;
          bottom: 20px;
          text-align: center;
          font-size: 16px;
          color: #EC7C4E;
          text-decoration: underline;
          cursor: pointer;
      }

      /* 学生抢答 */

      .interact-stu-ready {
          width: 100%;
          height: 100%;
          background: url("../../assets/images/interact-stu-ready_new.png") no-repeat center center;
          background-size: 100% 100%;
      }

      .interact-stu-answer {
          width: 100%;
          height: 100%;
          background:url("../../assets/images/stu-answer-ready-bg_new.png") no-repeat center center;
          background-size: 100% auto;
          overflow: hidden;
      }

      .interact-stu-answer-btn {
          width: 58%;
          height: 54%;
          margin: 85px auto 0;
          line-height: 209px;
          font-size: 26px;
          color: #EF672F;
          background: url("../../assets/images/interact-teacher-bg1_new.png") no-repeat center center;
          background-size: 100% auto;
          cursor: pointer;
          text-align: center;
      }
      .interact-stu-answer-btn-disabled{
          background: url("../../assets/images/interact-answer-btn-disabled.png") no-repeat center center;
          background-size: 100% auto;
      }

      .interact-stu-answer-success {
          width: 100%;
          height: 100%;
          padding-top: 200px;
          font-size: 26px;
          color: #EF672F;
          text-align: center;
          background: url("../../assets/images/interact-stu-answer-success_new.png") no-repeat center center;
      }

      .interact-stu-answer-success p:first-child {
          font-size: 46px;
          color: #EF672F;
          margin: 0;
      }

      .interact-stu-answer-success p:last-child {
          font-size: 26px;
          color: #EF672F;
          margin: 0;
      }

      .interact-stu-answer-fail {
          width: 100%;
          height: 100%;
          padding: 253px 40px 0;
          font-size: 22px;
          color: #EF672F;
          text-align: left;
          background: url("../../assets/images/interact-stu-answer-fail_new.png") no-repeat center center;
      }
        .interact-stu-answer-fail b{
             font-size: 28px !important;
        }
      /* 学生解锁屏 */

      .cover-lock-screen {
          position: absolute;
          z-index: 9999999999;
          left: 0;
          top: 0;
          right:0;
          bottom:0;
          width: 100%;
          height: 100%;
      }

      .cover-lock-screen img {
          width: 100%;
          height: 100%;
          background-size: 100% 100%;
      }

      /*  */

      .interaction_modal_bg {
          width: 100%;
          height: 100%;
          background: rgba(0, 0, 0, 0.40);
          position: relative;
          z-index: 10401;
      }

      .interact-tea-ans-content.ak-active {
          width: 300px;
          height: 316px;
          /* margin-left:-150px; */
      }

      .interact-tea-ans-content.ak-active .interact-time {
          margin: 40px auto 0;
          padding-top: 20%;
      }

      .interact-tea-ans-content.ak-active .interact-stu-answer-btn {
          margin: 60px auto 0;
          line-height: 168px;
          font-size: 24px;
      }

      .interact-tea-ans-content.ak-active .interact-stu-answer-success {
          padding-top: 200px;
          font-size: 22px;
      }

      .interact-tea-ans-content.ak-active .interact-stu-answer-fail {
          padding: 180px 26px 0;
          font-size: 18px;
      }

      .interact-tea-ans-content.ak-active .interact-result-title {
          margin: 40px auto 0;
      }

      .interact-tea-result-one-bg .result-no1 {
          top: 53px;
      }
      .new_toast {
          position: absolute;
          left: calc(50% - 5rem);
          top: calc(50% - 1rem);
          z-index: 999999999999;
          background: rgba(0,0,0,.8);
          border-radius: 1rem;
          color: #fff;
          padding: 0 .8rem;
          height: 2rem;
          line-height: 2rem;
          font-size: .8rem;
          width: auto;
      }

      .interact-ct-active {
          display: none;
      }

      /*随机抽查*/
      .random-smoke {
          position: absolute;
          left: 25px;
          top: 10px;
          font-size: 0.18rem;
          color: #D67067;
          cursor: pointer;
          text-decoration:underline
      }
      .random-sucess {
          background: url("../../assets/images/random-sucess-student.png") no-repeat center center;
          background-size: 100% 100%;
      }
      .random-fail {
          background: url("../../assets/images/random-fail-student.png") no-repeat center center;
          background-size: 100% 100%;
      }

      .random .result-no3 {
          right: 4%;
          top: 185px;
          width: 40%;
          height: 50%;
          text-align: center;
      }
      .random .result-no2 {
          left: 4%;
          top: 170px;
          width: 40%;
          height: 50%;
          text-align: center;
      }
      .random .result-no1 {
          top: 100px;
      }
      .interact-result .random-new-no1 {
          top: 100px;
      }
      .student-fail {
          padding: 190px 40px 0;
      }

      input::-webkit-input-placeholder {
          color: #ccc;
      }

    }
</style>
